import { Stack, styled, Theme, useTheme } from '@mui/material';
import { Badge } from 'sharedComponents/Badge';
import { Tooltip } from 'sharedComponents/Tooltip';
import { connectSchoolTagIcons } from './constants';
import React, { useState } from 'react';
import { ConnectSchoolTag } from 'types/connectTypes';
import { ConnectSchoolTagsSectionProps } from 'types/connectTypes';

export const SchoolTagsSection: React.FC<ConnectSchoolTagsSectionProps> = ({
  school,
  display_at,
}) => {
  const theme = useTheme();
  const schoolTags = school?.tags?.filter((tag) => tag.display_at?.includes(display_at));
  const [activeTooltip, setActiveTooltip] = useState<number | null>(null);
  const isMobile = window.matchMedia('(pointer: coarse)').matches;

  const handleTagClick = (index: number) => {
    if (isMobile) {
      setActiveTooltip(activeTooltip === index ? null : index);
    }
  };

  const handleTooltipClose = () => {
    setActiveTooltip(null);
  };

  const renderTag = (tag: ConnectSchoolTag, index: number) => (
    <Tooltip
      title={tag.tooltip}
      placement="bottom"
      arrow
      open={isMobile && activeTooltip === index}
      onClose={handleTooltipClose}
      disableFocusListener={isMobile}
      disableHoverListener={isMobile}
      disableTouchListener={isMobile}
    >
      <div
        onClick={() => handleTagClick(index)}
        style={{ cursor: isMobile ? 'pointer' : 'default' }}
      >
        <Badge icon={connectSchoolTagIcons[tag.icon]} sx={badgeStyles(theme)}>
          {tag.name}
        </Badge>
      </div>
    </Tooltip>
  );

  return (
    <SchoolTagsSectionContainer>
      <SchoolTagsBadgeContainer>
        {schoolTags.map((tag, index) => (
          <div key={`${tag.name}-${index}`}>{renderTag(tag, index)}</div>
        ))}
      </SchoolTagsBadgeContainer>
    </SchoolTagsSectionContainer>
  );
};

const SchoolTagsSectionContainer = styled(Stack)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

const SchoolTagsBadgeContainer = styled(Stack)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(1),
  flexWrap: 'wrap',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'stretch',
    width: '100%',
    '& > *': {
      width: '100%',
    },
  },
}));

const badgeStyles = (theme: Theme) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 0.5,
  padding: '1px 4px',
  borderRadius: theme.shape.borderRadius * 0.5,
  border: `1px solid ${theme.palette.gray.lighter}`,
  backgroundColor: theme.palette.gray.lighter,
  color: theme.palette.text.primary,
  fontSize: theme.typography.body3.fontSize,
  fontWeight: 500,
  cursor: 'default',
  pointerEvents: 'none',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    justifyContent: 'center',
  },
});
